import { Component, Input } from '@angular/core';
import moment from 'moment';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-message-content-cell',
  templateUrl: './message-content-cell.component.html',
  styleUrls: ['./message-content-cell.component.scss'],
})
export class MessageContentCellComponent {
  @Input() avatarUrl: string;
  @Input() name: string;
  @Input() date: Date;
  @Input() initials: string;
  @Input() message?: string;
  @Input() audioUrl?: string;
  @Input() imageUrl?: string;

  get formattedDate(): string {
    return moment(this.date).format('HH:mm');
  }

  get ephemeralMedia(): boolean {
    return (!!this.audioUrl || !!this.imageUrl) && !this.message;
  }

  formatMessage(messageContent: string): string {
    let formattedMessage = '';
    const regexp =
      /https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)/gi;
    const result = [...messageContent.matchAll(regexp)];
    let pos = 0;
    for (const r of result) {
      const value = r[0];
      const index = r.index ?? 0;
      formattedMessage += messageContent.substring(pos, index);
      formattedMessage += '<span class="conversation-link">';
      formattedMessage += '<img src="' + value + '/favicon.ico" alt="">';
      formattedMessage += '<a href="' + value + '" target="_blank">';
      formattedMessage += value;
      formattedMessage += '</a>';
      formattedMessage += '</span>';
      pos = index + value.length;
    }
    formattedMessage += messageContent.substring(pos, messageContent.length);

    const regexpMail = /[\w.]+@([\w-]+\.)+[\w-]{2,4}/gi;
    formattedMessage = formattedMessage.replaceAll(regexpMail, (substring) => {
      return (
        '<span class="conversation-email">' +
        '<img src="assets/images/envelope-regular.svg" alt="">' +
        '<a href="mailto:' +
        substring +
        '">' +
        substring +
        '</a></span>'
      );
    });
    return formattedMessage;
  }
}
